<!--
 * @Descripttion:
 * @version:
 * @@Company: HDWB
 * @Author: cwl
 * @Date: 2022-07-28 08:55:06
 * @LastEditors: cwl
 * @LastEditTime: 2022-08-01 13:46:14
-->
<template>
  <div class="my-collection">
    <div class="collection-img">
        <img :src="obj.list_img_pc || obj.list_img" alt="">
        <div class="intro-pop">
            <div class="intro-box">
              <div class="title">
                {{obj.exhibit_name}}
              </div>
              <!-- <div class="size">
                {{obj.exhibit_attribute}}
              </div> -->
              <div class="intro" v-html="obj.content">
                <!-- 云想衣裳花想容，春风扶栏露华浓。若非群玉山头见，会向瑶台月下逢。
                一枝秾艳露凝香，云雨巫山枉断肠。借问汉宫谁得似，可怜飞燕倚新妆。 -->
              </div>
            </div>
            <div class="btn" @click="toDetail">
              查看详情
            </div>
        </div>
    </div>
    <div class="collection-text">
      {{ obj.exhibit_name }}
    </div>

  </div>
</template>
<script>
export default {
  props: {
    obj: {
      type: Object,
      require: true
    }
  },
  data () {
    return {

    }
  },
  methods: {
    toDetail () {
      // 1全部   2 官网  3小程序
      if (Number(this.obj.plat) == 3) {
        this.$message.error('请到小程序查看展品详细信息!')
        return
      }
      this.$router.push({path:'/zh-CN/exhibitsDetail', query: {exhibit_id:this.obj.exhibit_id,zhtype:'展览详情',navIndex:2}})

    }
  }
}
</script>
<style lang="scss" scoped>
.my-collection {
  width: 286px;
  height: 345px;
  .collection-img {
    position: relative;
    width: 286px;
    height: 286px;
    background: rgba(170,170,170,1);
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .intro-pop {
      display: none;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(0,39,70,0.78);
      padding-top: 58px;
      box-sizing: border-box;
      animation: slideUpIn 0.3s linear forwards;
      -webkit-animation: slideUpIn 0.3s linear forwards;
      -moz-animation: slideUpIn 0.3s linear forwards;
      -o-animation: slideUpIn 0.3s linear forwards;
      overflow: hidden;
      .intro-box {
        width: 240px;
        height: 114px;
        margin: 0 auto;
        .title {
          width: 100%;
          height: 20px;
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
          font-family: 'Microsoft YaHei';
          font-weight: 400;
          font-size: 17.98px;
          color: #F0A842;
        }
        .size, .intro {
          width: 100%;
          height: 20px;
          line-height: 20px;

          text-align: center;
          font-family: 'Microsoft YaHei';
          font-weight: 400;
          font-size: 13.98px;
          color: #FFFFFF;
          margin-top: 15px;
        }
        .size {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .intro {
          height: 80px;
          display:-webkit-box;
          overflow: hidden; /*超出隐藏*/
          text-overflow: ellipsis;/*隐藏后添加省略号*/
          -webkit-box-orient:vertical;
          -webkit-line-clamp: 4; //想显示多少行
        }
      }
      .btn {
        display: block;
        width: 96px;
        height: 31px;
        line-height: 31px;
        border:1px solid rgba(233,171,67,1);
        font-weight: 400;
        font-size: 13.98px;
        text-align: center;
        color: #F0A842;
        margin: 37px auto 0;
        box-sizing: border-box;
        cursor: pointer;
      }
    }
    &:hover {
      .intro-pop {
        display: block;
      }
    }
    @keyframes slideUpIn {
      from {
        height: 0;
      }
      to {
        height: 100%;
      }
    }
    @-webkit-keyframes slideUpIn {
      from {
        height: 0;
      }
      to {
        height: 100%;
      }
    }
    @-moz-keyframes slideUpIn {
      from {
        height: 0;
      }
      to {
        height: 100%;
      }
    }
    @-o-keyframes slideUpIn {
      from {
        height: 0;
      }
      to {
        height: 100%;
      }
    }
  }
  .collection-text {
    width: 286px;
    height: 59px;
    background: rgba(238,238,238,1);
    font-weight: 400;
    line-height: 59px;
    font-size: 20px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 10px;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/zh-colection.vue